// client/src/styles/errorBoundaryStyles.js
import { styled } from 'baseui';

export const StyledErrorContainer = styled('div', {
  padding: '20px',
  textAlign: 'center',
});

export const StyledErrorPre = styled('pre', {
  whiteSpace: 'pre-wrap',
  background: '#f0f0f0',
  padding: '10px',
});
